const DEFAULT_ID = null

export default DEFAULT_ID
